import Cookies from 'js-cookie';

import { HttpClient } from './http-client';

import { HSM_BACKEND_URL } from '@/constants/environment';

export interface HsmBackendResponse<T> {
  result: T;
  code: string;
  statusCode: number;
  description: string;
}

export interface HsmBackendResponseList<T> {
  result: T[];
  code: string;
  statusCode: number;
  description: string;
}

/**
 * Singleton HttpClient for WorkflowPlatform communications
 */
export class HsmBackendHttpClient extends HttpClient {
  private static _instance: HsmBackendHttpClient;

  private constructor() {
    super(HSM_BACKEND_URL);
    this.setAuthorization(Cookies.get('jwt') || 'jwt.not.set');
  }

  public static get instance() {
    return this._instance || (this._instance = new HsmBackendHttpClient());
  }
}
